/**
 * manualAck.js — regras do aceite do manual do usuário.
 *
 * Módulo próprio (e não dentro do App.js) para evitar ciclo de import:
 * o App.js carrega a página Manual via lazy(), e a página precisa das mesmas
 * constantes. Ambos importam daqui.
 */

// Dispensa temporária ("Ainda não li").
//
// Guardamos o TOKEN sob o qual a dispensa foi feita, não um simples '1'.
// Motivo: sessionStorage sobrevive a logout/login na mesma aba, então um
// marcador booleano faria o manual sumir para sempre naquela aba. Comparando
// com o token atual, a dispensa vale só enquanto durar aquele login — em cada
// novo login o manual volta a aparecer, até o usuário confirmar de fato.
export const MANUAL_DISMISS_KEY = 'jk_manual_dismissed';

const tokenAtual = () => {
  try {
    return localStorage.getItem('token') || '';
  } catch {
    return '';
  }
};

/** Registra que o usuário escolheu "Ainda não li" neste login. */
export const marcarManualAdiado = () => {
  try {
    const t = tokenAtual();
    if (t) sessionStorage.setItem(MANUAL_DISMISS_KEY, t);
  } catch {
    // sessionStorage indisponível: sem dispensa, o manual segue aparecendo.
  }
};

/**
 * O manual ainda precisa ser confirmado por este usuário?
 *
 * FAIL-SAFE deliberado: só retorna true quando o servidor informa
 * `manual_current_version`. Se o backend ainda não tiver sido atualizado, o
 * campo vem undefined e ninguém é redirecionado — um deploy fora de ordem
 * (frontend antes do backend) nunca prende o usuário fora do sistema.
 */
export const precisaConfirmarManual = (user) => {
  if (!user || !user.manual_current_version) return false;
  if (user.manual_ack_version === user.manual_current_version) return false;
  try {
    const adiado = sessionStorage.getItem(MANUAL_DISMISS_KEY);
    // Só honra a dispensa se ela foi feita neste mesmo login.
    if (adiado && adiado === tokenAtual()) return false;
  } catch {
    // sessionStorage indisponível (modo restrito): segue e mostra o manual.
  }
  return true;
};
